import { createContext } from 'react'

/**
 * Можно использовать, чтобы прокинуть портал через контекст до вложенного BottomSheet
 */
export const BottomSheetContext = createContext<{
  bottomSheetPortal: HTMLElement | null
}>({ bottomSheetPortal: null })

/**
 * Настройки BottomSheet
 */
export const BottomSheetSettingsContext = createContext<{
  withoutAnimation: boolean
}>({ withoutAnimation: false })
